import React, { Component, PropTypes } from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
const gaEvent = require('../../lib/googleAnalytics').gaEvent();

// action creators for redux
import * as asyncActionCreators from '../../redux/actionCreators/async';

import * as ui from '../../redux/actionCreators/sync/ui';

// get validations
import {getSchema as getCompanySchema} from '../../models/company';
import {getSchema as getUserSchema} from '../../models/user';
import {getSchema as getContactSchema} from '../../models/contactProfile';

import DropdownChecklist from '../../common/components/DropdownChecklist';
import InfoModal from '../../common/components/f_InfoModal';
import InfoIcon from '../../common/svgs/InfoIcon';
import Copyright from '../f_copyright/index';
import { convertToMenuItems } from '../../redux/helpers/staticData';
import { extractCompanyUrlFromEmail } from '../../lib/formatCompanyUrl';
import { defaultOrdering } from '../../lib/dropdowns';
import {parentChildList} from '../../lib/parentChildList';
import { activeSegmentTypes } from '../../lib/industrySegments';
import { referralsByRole } from '../../lib/staticData';

let validationObj = {};

function validationSchema(component) {
	const iiabaState = {
		custom: {
			func(val) {
				const state = _.get(component, 'state.prospectModel') || {};
				const tradeAssociations = _.get(state, 'company.tradeAssociations', []);
				const iiabaState = (_.isString(val) && !val.length) ? null : val;
				if (tradeAssociations.length && tradeAssociations.includes(4) && _.isNil(iiabaState)) {
					return false;
				}

				return true;
			},
			message : 'Please choose a member state.'
		}
	};

  const address = {
    required: {
      message: 'This field is required.'
    }
  };

  const numberOfOffices = {
    isNumeric: {
      message: 'Must be numeric'
    },
    required: {
      message: 'This field is required.'
    }
  };

  const phoneNumber1 = {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
        message: 'Must be a valid phone number.'
    }
  };

  return {
		user: _.omit(getUserSchema(), ['password', 'timezone']), // password gets validated in the next step
		profile: getContactSchema(),
		company: _.merge({}, getCompanySchema(), {iiabaState}, {address}, {numberOfOffices}, {phoneNumber1})
	};
}

// js utility library
import _, { get, find, isNil } from 'lodash';
// import components from material UI
import muiThemeable from 'material-ui/styles/muiThemeable';

// import customized versions of components from material UI
import TextField from '../../common/components/c_TextField';
import TextArea from '../../common/components/c_TextArea';
import MaskedTextField from '../../common/components/c_MaskedTextField';
import DropDownMenu from '../../common/components/c_DropDownMenu';
import SimpleDropDownMenu from '../../common/components/SimpleDropDownMenu';
import CheckList from '../../common/components/c_CheckList';
import RaisedButton from '../../common/components/c_RaisedButton';

@connect(store => ({
	currentUser: store.user,
	contacts: get(store.admin.contacts, 'items', []),
	staticData: store.staticData,
	labels: get(store.labels, 'ProspectForm', {}),
	commonLabels: get(store.labels, 'Common', {}),
	scrollBarWidth: store.browserData.scrollBarWidth,
}))

@muiThemeable()export default class ProspectForm extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		children :PropTypes.any,
		currentUser: PropTypes.object.isRequired,
		staticData: PropTypes.object.isRequired,
		scrollBarWidth: PropTypes.number,
		asAdmin: PropTypes.bool,
		contacts: PropTypes.array,
		labels: PropTypes.object
	};

	constructor(props, context) {
		super(props, context);

		// need to bind functions to self either here or in render
		this.handleUI = ::this.handleUI;
		this.handleUIParentChildDropdown = ::this.handleUIParentChildDropdown;
		this.submitForm = ::this.submitForm;
		this.loadContact = ::this.loadContact;
		this.hideSnackbar = ::this.hideSnackbar;
		this.onChange = (parent, child, event, newVal, ...others) => { // eslint-disable-line no-unused-vars

      if (parent==='company' && child === 'segmentTypes' && isNil(newVal)) return; // WPS-43 - do not clear segment types when parent changes

      // update field
			// preparing new value in required object format
			const obj = {
				prospectModel: {}
			};
			obj.prospectModel[parent] = {};
			obj.prospectModel[parent][child] = newVal;

			// adding hacky solution for adding correct data in each state update.
			// getting current state, adding new data.
			const result = _.merge({}, this.state);
			result.prospectModel[parent][child] = newVal;

			// setting previous state with new data.
			this.setState(result);
		};

		this.onErrorChange = changeInt => {
			const errorCount = this.state.errorCount + changeInt;
			const showErrorMessage = this.state.showErrorMessage && !!errorCount;
			this.setState(_.merge(this.state, {
				errorCount,
				showErrorMessage
			}));
		};

		validationObj = validationSchema(this);

		this.parentChildHandlers = parentChildList();


	}
	state = {
		errorCount: 0,
		prospectModel:{
			user: {},
			profile:{},
			company:{}
		},
		storedModel: null,
		showSuccess: false,
		showErrorMessage: false,
		duplicateEmail: false,
		userData: {},
		formSubmitted: false,
		showSnackbar: false,
		snackBarText: '',
		lastContactId: null,
		editMode: false,
		checkContact: !this.props.asAdmin
	}

	componentDidUpdate() {

		if(this.props.asAdmin && this.state.formSubmitted) {
			this.setState({formSubmitted: false});
			this.props.dispatch(ui.showSnackBar(`${this.state.prospectModel.user.firstName} ${this.state.prospectModel.user.lastName} has been added`))
			// for now go back to contacts screen
			this.props.dispatch(push('/admin/contacts'));
		}
	}

	loadContact() {
		// const contact = findContact({profile: {id: this.state.lastContactId}}, this.props.contacts);
		this.setState({
			prospectModel: this.state.storedModel,
			showSnackbar: false,
			editMode: true
		});
	}

	hideSnackbar() {
		this.setState({
			showSnackbar: false
		});
	}

	submitForm() {

		if(this.state.errorCount === 0) {
			if (this.props.asAdmin) {
				this.state.prospectModel.profile.createdBy = this.props.currentUser.id;
			}

			// if we're in the first part of the form, check only contact info
			if (this.state.checkContact) {
				const companyDomain = extractCompanyUrlFromEmail(this.state.prospectModel.user.email);
				this.state.prospectModel.company.website = companyDomain;

				this.props.dispatch(asyncActionCreators.checkAndCreateContact(this.state.prospectModel, {
						success: (data) => {
							this.setState(_.merge(this.state, {
								showSuccess: true,
								userData: data[0],
								formSubmitted: true,
								storedModel: this.state.prospectModel
							}));

							gaEvent('Client', 'Client Success', 'WAHVE Client');
						},
						error: (err) => {

							const customError = _.get(err, 'body.errors[0]', _.get(err, 'body.data.items[0]'));
							if(_.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
								this.handleDuplicateEmail(customError);
							}
							else if(_.get(customError, 'errorCode') === 'NEW_CONTACT') {
								this.setState({checkContact: false}, () => {
									// go to state so that we scroll further down than just the first line
									const companySection = ReactDOM.findDOMNode(this.refs.state);
									if (companySection) {
										companySection.scrollIntoView(false);
									}
								});
							}
						}
					}
				));
			}
			else {
				// standard submit
				if (this.state.editMode) {
					// set ID vars
					this.state.prospectModel.contactId = this.state.lastContactId;
					this.state.prospectModel.user = {id: this.state.lastContactId};

					this.props.dispatch(asyncActionCreators.updateProspect(this.state.prospectModel, {
						success: (data) => {
							this.setState(_.merge(this.state, {
								editMode: false,
								userData: data[0],
								formSubmitted: true,
								storedModel: this.state.prospectModel
							}));
						},
						error: (err) => {
							console.log('got error', err);
						}
					}));
				}
				else {
          const companyDomain = extractCompanyUrlFromEmail(this.state.prospectModel.user.email);
          this.state.prospectModel.company.website = companyDomain;
					this.props.dispatch(asyncActionCreators.createProspect(this.state.prospectModel, {
							success: (data) => {
								data[0].password = '';
								this.setState(_.merge(this.state, {
									showSuccess: true,
									userData: data[0],
									formSubmitted: true,
									storedModel: this.state.prospectModel
								}));

								gaEvent('Client', 'Client Success', 'WAHVE Client');
							},
							error: (err) => {

								const customError = _.get(err, 'body.data.items[0]');

								if(_.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
									this.handleDuplicateEmail(customError);
								}

								console.log('got error', err);
							}
						}
					));
				}
			}
		} else {
			for (const refKey in this.refs) {
				if (this.refs[refKey].checkErrors) {
					this.refs[refKey].checkErrors();
				}
			}
			this.setState(_.merge(this.state, {
				showErrorMessage: true
			}));
		}
	}

	handleDuplicateEmail(customError) {
		const clientAdvisor = customError.clientAdvisor;
		const userFirstName = customError.userFirstName;
		const { failExisting } = this.props.labels;

		const errorText = `
		Hello ${userFirstName}. ${failExisting}`;

		const updatedState = {
			duplicateEmail: true,
			duplicateEmailText: errorText
		};

		if (clientAdvisor !== undefined) {
			if (clientAdvisor.email !== undefined) {
				updatedState.clientAdvisorEmail = clientAdvisor.email;
			}
		}

		this.setState(updatedState);
	}

	// handleUI removes the 'required' property from fields in the model
	// so that they aren't validated in certain instances
	// should probably rename this to something more useful like configureValidationModel
	handleUI(parent, child) {

		let propValidationObj = validationObj[parent][child];

		// never validate company.numberOfEmployees
		if (parent === 'company' && child === 'numberOfEmployees') {
      propValidationObj = _.omit(propValidationObj, ['required']);
		}

		// Remove 'required' property from several fields when internal user is entering data
		// Necessary because internal user may not have certain information available at this time
		if (this.props.asAdmin) {

			if (parent === 'user' && ['timezone'].includes(child)) {
				// Timezone (User)
					propValidationObj = _.omit(propValidationObj, ['required']);
			}

			if (parent === 'company' &&
						['numberOfOffices', 'numberOfEmployees', 'isDivisionOrSubsidiary', 'industryTypes', 'segmentTypes',
						'tradeAssociations', 'affiliationTypes', 'address'].includes(child)) {
				// Number of offices (Company)
				// Number of employees (Company)
				// Are you a subsidiary (Company)
				// Industry Types
				// Industry Segments
				// Trade Associations
				// Affiliations
        // Address
				propValidationObj = _.omit(propValidationObj, ['required']);
			}

			if (parent === 'profile' && ['foundUsVia', 'initialInquiry'].includes(child)) {
				propValidationObj = _.omit(propValidationObj, ['required']);
			}
		}

		// add required field validation for industry other and segment other...
		if (child === 'industryOther' || child === 'segmentOther') {
			propValidationObj = {
				required : {
					message : 'This field is required'
				}
			};
		}

		return {
			'data-id': `${parent}.${child}`,
			floatingLabelText: get(this.props.labels, `${parent}.${child}`),
			onBlur: this.onChange.bind(this, parent, child),
			onErrorChange: this.onErrorChange,
			ref: child || parent,
			validation: propValidationObj,
			defaultValue: this.state.prospectModel[parent][child] || ''
		};
	}

	handleUIParentChildDropdown(parent, child, menuItems) {
    return {
      menuItems,
      ...this.handleUI(parent, child)
    };
	}

	handleDropdown(parent, child) {
		const {
			onBlur,
			...rest
		} = this.handleUI(parent, child);
		return {
			onChange: onBlur,
			...rest
		};
	}

	completeProspectForm() {

		if (this.props.asAdmin) {
				this.setState({showSuccess: false, duplicateEmail: false});
		} else {
				window.location.assign(this.props.commonLabels.website);
		}

	}

	render() {
		const {
			scrollBarWidth
		} = this.props;

		const {
			stateList,
			timezoneList,
			segmentTypes,
			industryTypesList,
			tradeAssociations,
			iiabaStates,
			affiliationTypes,
			foundUsViaList,
			contactPhoneTypes
		} = this.props.staticData;

		const foundUsVia = referralsByRole(foundUsViaList, 'C');

		const {
			company = {},
			profile = {}
		} = this.state.prospectModel;

		const industrySegmentTypes = activeSegmentTypes(segmentTypes, industryTypesList, get(company, 'industryTypes'), get(company, 'segmentTypes'));

		let yesNoItems = [
			{
				primaryText : 'Yes',
				subElement : null,
				value :true
			},		{
				primaryText : 'No',
				subElement : null,
				value : false
			}
		];

		let textForModal = {
			prompt: 'You can create a login to access your Contact Information or you can click on the X to exit.',
			buttonLabel: 'Continue'
		};

		const	successText = [<h1>{get(this.props.labels, 'successHeader')}</h1>,
				<br />,
				<br />,
				`Hello ${get(this.state, 'prospectModel.user.firstName', '')}. `,
				get(this.props.labels, 'successBody')
		];

		const successTextExistingCompany = [
			<h1>{get(this.props.labels, 'successHeader')}</h1>,
				<br />,
				<br />,
				`Hello ${get(this.state, 'prospectModel.user.firstName', '')}. `,
				get(this.props.labels, 'successBodyExisting')
		];
		const mainPhone = find(contactPhoneTypes, {name: 'Main'});
		const mainPhoneId = get(mainPhone, 'id');

		const {parent: industryTypeProps, child: segmentTypeProps} = this.parentChildHandlers({
      parentProps: this.handleUIParentChildDropdown('company', 'industryTypes', industryTypesList),
      childProps: this.handleUIParentChildDropdown('company', 'segmentTypes', segmentTypes),
   });

		return (
			<div className={this.props.asAdmin ? '' : 'content-container'}>
				{
					this.state.duplicateEmail
					&&
					<InfoModal
						cancelFunc={::this.completeProspectForm}
						buttonLabel={'close'}
						transitionFunc={this.completeProspectForm.bind(this)}
						text={this.state.duplicateEmailText}
					/>
				}

				{
					this.state.showSuccess
					&&
          !this.props.asAdmin
          &&
					<InfoModal
						cancelFunc={::this.completeProspectForm}
						buttonLabel={'close'}
						transitionFunc={::this.completeProspectForm}
						text={this.state.checkContact ?  successTextExistingCompany : successText } />
				}

				<form ref='prospectForm' className={'prospect-form application-form clearfix'}>
					<div className='form-section clearfix'>
					<section id='Contact_Info'>
							<h1 className='form-section-header'>
								Contact Information
							</h1>
            <br></br>
            <div style={{display: 'flex', lineHeight: '30px'}}>
              <img width={40} height={30} src={'assets/images/canada-flag.png'} alt={'Canada Flag'}/>
              <span style={{paddingLeft: '10px'}}>
              For Canadian talent&nbsp;
                <a href='https://wahve.com/find-canadian-talent' className='link login-link' data-id='Canadian Prospects'>
                click here.
              </a>
            </span>
            </div>

            <div className='box-container-fixed clearfix'>
                <div className='box'>
                  <TextField
                    {...this.handleUI('user', 'firstName')}
										floatingLabelText='First Name' />
                </div>
                <div className='box'>
                  <TextField
                    {...this.handleUI('user', 'lastName')}
										floatingLabelText='Last Name' />
                </div>
                <div className='box'>
                  <TextField
                    {...this.handleUI('profile', 'title')}
										floatingLabelText='Title' />
                </div>
                <div className='box'>
                  <TextField
                    disabled={this.state.editMode}
                    {...this.handleUI('user', 'email')}
										floatingLabelText='Email Address' />
                </div>
                <div className='box'>
                  <div className='box-c'>
                    <div className='box-i'>
                      <MaskedTextField
                        hideMaskChar
                        mask='(999) 999-9999'
                        {...this.handleUI('user', 'phoneNumber1')}
												floatingLabelText='Phone Number' />
                    </div>
                    <div className='box-i'>
                      <DropDownMenu
                        menuItems={contactPhoneTypes}
                        {...this.handleUI('user', 'phoneType1')}/>
                    </div>
                  </div>
                </div>
                {
                  get(this.state.prospectModel, 'user.phoneType1') === mainPhoneId &&
                  <div className='box'>
                    <TextField {...this.handleUI('user', 'phoneExtension1')}
											floatingLabelText='Extension' />
                  </div>
                }
                <div className='box'>
                  <TextField
                    {...this.handleUI('profile', 'department')}
										floatingLabelText='Department' />
                </div>
                <div className='box'>
                  <DropDownMenu
                    menuItems={timezoneList}
                    {...this.handleUI('user', 'timezone')}
										floatingLabelText='Time Zone' />
                </div>
								<div className='box'>
									<TextField
										{...this.handleUI('company', 'name')}
										floatingLabelText='Company Name' />
								</div>
							</div>

						</section>
						</div>
						{!this.state.checkContact
							&&
							<ReactCSSTransitionGroup
			          transitionName="prospect-company-transition"
			          transitionEnterTimeout={700}
			          transitionLeaveTimeout={500}
								transitionAppear={true}
      					transitionAppearTimeout={700}>
								<div className="prospect-company-info" key="prospect-company-info">
									{!this.props.asAdmin
										&&
										<div ref="infomsg" className='contact-company-info-message'><InfoIcon /> {this.props.labels.companyInformation} </div>
									}
									<div className='form-section clearfix'>
										<section id='Company_Info'>
										<h1 className='form-section-header'>
											Company Information
										</h1>

										<div className='box-container-fixed'>
											{
												!this.props.asAdmin
												&&
												<div className='box'>
													<TextField
														{...this.handleUI('company', 'name')}
														disabled
														floatingLabelText='Company Name'
													/>
												</div>
											}
			                <div className='box'>
			                  <TextField
			                    {...this.handleUI('company', 'address')}
													floatingLabelText='Street Address' />
			                </div>
			                <div className='box'>
			                  <TextField
			                    {...this.handleUI('company', 'city')}
													floatingLabelText='City' />
			                </div>
			                <div className='box'>
			                  <div className='box-c'>
			                    <div className='box-i'>
			                      <SimpleDropDownMenu
			                        menuItems={stateList}
			                        underlineStyle={{margin: '-1px 0px'}}
			                        iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
			                        labelStyle={{paddingLeft: '0px'}}
			                        {...this.handleUI('company', 'state')}
															floatingLabelText='State' />
			                    </div>
			                      <div className='box-i'>
			                        <TextField
			                          type='number'
			                          maxLength='5'
			                          {...this.handleUI('company', 'zip')}
																floatingLabelText='Zip' />
			                      </div>
			                    </div>
			                  </div>
			                <div className='box'>
			                  <MaskedTextField
			                    mask='(999) 999-9999'
			                    hideMaskChar
			                    {...this.handleUI('company', 'phoneNumber')}
													floatingLabelText='Phone Number' />
			                </div>
			                <div className='box'>
			                  <TextField
			                    {...this.handleUI('company', 'numberOfOffices')}
													floatingLabelText='Number of Offices' />
			                </div>
			                <div className='box'>
			                  <TextField
			                    {...this.handleUI('company', 'numberOfEmployees')}
													floatingLabelText='Number of Employees' />
			                </div>
			                <div className='box'>
			                  <DropDownMenu
			                    menuItems={yesNoItems}
			                    {...this.handleUI('company', 'isDivisionOrSubsidiary')}
													floatingLabelText='Are you a division or subsidiary of another company? ' />
			                </div>
											{
												(company.isDivisionOrSubsidiary)
												&&
			                  <div className='box'>
			                    <TextField
			                      {...this.handleUI('company', 'parentCompany')}
														floatingLabelText='Parent Company Name'
			                    />
			                  </div>
											}
			              </div>
										</section>
			            </div>

									<div className='form-section clearfix'>
									<section id='Preliminary_Info'>
										<h1 className='form-section-header'>
												Preliminary Information
										</h1>
										<div className='box-container-fixed clearfix'>

			                <div className='box'>
			                  <CheckList
			                    scrollBarWidth={scrollBarWidth}
			                    {...industryTypeProps} />
								{
									this.props.labels.company.industryTypesSubText
									&&
									<div className='label'>{this.props.labels.company.industryTypesSubText}</div>
								}
			                </div>

											{
												company.industryTypes && company.industryTypes.includes((industryTypesList.find((i) => i.name === 'Other') || {}).id)
												&&
			                  <div className='box'>
			                    <TextField
			                      {...this.handleUI('company', 'industryOther')}
														floatingLabelText='Type of Firm Other' />
			                  </div>
											}

											<div className='box'>
												<DropdownChecklist
													data-id={'company.segmentTypes'}
													textLabel={get(this.props.labels, 'company.segmentTypes')}
													menuItems={industrySegmentTypes}
													value={get(company, 'segmentTypes')}
													groupBy={'parentName'}
													onChange={this.onChange.bind(this, 'company', 'segmentTypes')}
													errorText={'This field is required'}
													dirty={!!get(this.state, 'prospectModel.company.industryTypes', false)}
													required
												/>
												{
              										this.props.labels.company.segmentTypesSubText
              										&&
              										<div className='label'>{this.props.labels.company.segmentTypesSubText}</div>
            									}
											</div>

											{
												company.segmentTypes && company.segmentTypes.includes((segmentTypes.find((s) => s.name === 'Other') || {}).id)
												&&
			                  <div className='box'>
			                    <TextField
			                      {...this.handleUI('profile', 'segmentOther')}
														floatingLabelText='Industry Segment Other' />
			                  </div>
											}
                      {
                        !!(tradeAssociations && tradeAssociations.length)
												&&
                        <div className='box'>
                          <CheckList
                            floatingLabelStyle={{ whiteSpace: 'pre-wrap', transform: 'translateY(-20px)' }}
                            menuItems={convertToMenuItems(tradeAssociations, 'id', 'crmName')}
                            {...this.handleUI('company', 'tradeAssociations')} />
                          </div>
                      }

											{
												!!(company.tradeAssociations && (company.tradeAssociations.includes((tradeAssociations.find(t => t.name === 'Other') || {}).id)))
												&&
			                  <div className='box'>
			                    <TextField
			                      {...this.handleUI('company', 'associationOther')}
														floatingLabelText='Trade Associations Other' />
			                  </div>
											}

											{
											  !!(company.tradeAssociations && (company.tradeAssociations.indexOf(4) != -1))
												&&
			                  <div className='box'>
			                    <DropDownMenu

			                      floatingLabelStyle={{whiteSpace: 'pre-wrap', transform: 'translateY(-40px)'}}
			                      menuItems={iiabaStates}
			                      {...this.handleDropdown('company', 'iiabaState')}
														floatingLabelText={get(this.props.labels, 'company.iiabaState')} />
			                  </div>
											}

											{get(this.props.labels, 'company.networkAffiliationsYesNo', false)
												&&
												<div className='box'>
				                  <DropDownMenu
				                    menuItems={yesNoItems}
				                    {...this.handleUI('company', 'networkAffiliationsYesNo')}  />
				                </div>
											}

											{
												!!(company.networkAffiliationsYesNo && (company.networkAffiliationsYesNo == 1))
												&&
			                  <div className='box'>
			                    <CheckList
			                      menuItems={affiliationTypes}
			                      {...this.handleUI('company', 'affiliationTypes')}
														floatingLabelText='Please select the affiliation or network.' />
			                  </div>
											}

											{
												company.affiliationTypes && (company.affiliationTypes.includes((affiliationTypes.find((a) => a.name === 'Other') || {}).id))
												&&
			                  <div className='box'>
			                    <TextField
			                      {...this.handleUI('company', 'affiliationOther')}
														floatingLabelText='Network Affiliations Other' />
			                  </div>
											}
			                <div className='box'>
			                  <SimpleDropDownMenu
			                    menuItems={foundUsVia.sort(defaultOrdering)}
			                    underlineStyle={{margin: '-1px 0px'}}
			                    iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
			                    labelStyle={{paddingLeft: '0px'}}
			                    {...this.handleUI('profile', 'foundUsVia')} />
			                </div>

											{
                        (foundUsViaList.find((f) => f.name === 'Other, Please Specify:') || {}).id === profile.foundUsVia
												&&
			                  <div className='box'>
			                    <TextField
			                      {...this.handleUI('profile', 'foundUsOther')}
														floatingLabelText='Please Specify' />
			                  </div>
											}

											</div>
										</section>
										</div>
										<div className='form-section clearfix'>
										<section id='Inquiry_Reason'>
											<h1 className='form-section-header'>
												Inquiry Reason
											</h1>
											<div className='form-section-content clearfix'>

												<TextArea
													className='center-column-1 inquiry'
													description='Please tell us what type of help you are looking for.'
													{...this.handleUI('profile', 'initialInquiry')}/>

											</div>
										</section>
									</div>
								</div>
							</ReactCSSTransitionGroup>
						}

						<div className='form-submit-container'>
							<RaisedButton
								label='Continue'
								onClick={this.submitForm}/>
							{
								this.state.showErrorMessage
								&&
								<div className='error-message'>Please fill out the required fields above.</div>
							}
						</div>

				</form>

      <Copyright />
			</div>
	);
	}
}



// WEBPACK FOOTER //
// ./shared/react/public/ProspectForm.js